<button class="close-btn btn btn-hero-icon" style="color:#FFFFFF" (click)="onClose()">
  <i class="fa fa-times-circle-o" aria-hidden="true"></i>
</button>

<div class="section-title">
  {{ sectionTitle }}
</div>

<div class="topic-title">
  <p>{{ topicTitle }}</p>
</div>

<div class="topic-description">
  <p>{{ topicDescription }}</p>
</div>

<div class="content">
  <div class="relevance d-flex">
    <div class="strength" (click)="!readOnly && toogleStrength()" [ngClass]="{'pointer' : !readOnly}">
      <div class="select" >
        <i *ngIf="isStrength" class="fa fa-check-square-o fa-fw" aria-hidden="true"></i>
        <i *ngIf="!isStrength" class="fa fa-square-o fa-fw" aria-hidden="true"></i>
      </div>
      My Strength
    </div>
    <div class="development" (click)="!readOnly && toogleDevelopment()" [ngClass]="{'pointer' : !readOnly}">
      <div class="select">
        <i *ngIf="isDevelopment" class="fa fa-check-square-o fa-fw" aria-hidden="true"></i>
        <i *ngIf="!isDevelopment" class="fa fa-square-o fa-fw" aria-hidden="true"></i>
      </div>
      For Development
    </div>
    <div class="not-important" (click)="!readOnly && toogleNotImportant()" [ngClass]="{'pointer' : !readOnly}">
      <div class="select" >
        <i *ngIf="isNotImportant" class="fa fa-check-square-o fa-fw" aria-hidden="true"></i>
        <i *ngIf="!isNotImportant" class="fa fa-square-o fa-fw" aria-hidden="true"></i>
      </div>
      Not Relevant
    </div>
    <div class="achieved" (click)="!readOnly && toogleAchieved()" [ngClass]="{'pointer' : !readOnly}">
      <div class="select" >
        <i *ngIf="isAchieved" class="fa fa-check-square-o fa-fw" aria-hidden="true"></i>
        <i *ngIf="!isAchieved" class="fa fa-square-o fa-fw" aria-hidden="true"></i>
      </div>
      Achieved
    </div>
  </div>

  <div class="additional-content strength-content" *ngIf="isStrength">
    <hr>

    <textarea [disabled]="readOnly" placeholder="Please describe the value of this strength." class="hero-textarea-adjust" [(ngModel)]="valueOfStrength"></textarea>

  </div>

  <div class="additional-content development-content" *ngIf="isDevelopment">
    <hr>
    <textarea [disabled]="readOnly" placeholder="Development goals." class="hero-textarea-adjust" [(ngModel)]="developmentGoals"></textarea>

    <div class="action-plan" *ngFor="let action of actionPlans">
      <textarea [disabled]="readOnly" placeholder="Action plan." class="hero-textarea-adjust" [(ngModel)]="action['plan']"></textarea>
      <div class="dates">
        <div class="area">
          <div>Area:</div>
          <div>
            <select [disabled]="readOnly" [(ngModel)]="action['area']">
              <option value="">Internal/External</option>
              <option value="internal">Internal</option>
              <option value="external">External</option>
            </select>
          </div>
        </div>
        <div class="from">
          <div>
            From:
          </div>
          <div>
            <select [disabled]="readOnly" [(ngModel)]="action['from'][0]">
              <option value="">Month</option>
              <option value="1">January</option>
              <option value="2">February</option>
              <option value="3">March</option>
              <option value="4">April</option>
              <option value="5">May</option>
              <option value="6">June</option>
              <option value="7">July</option>
              <option value="8">August</option>
              <option value="9">September</option>
              <option value="10">October</option>
              <option value="11">November</option>
              <option value="12">December</option>
            </select>
            <select [disabled]="readOnly" [(ngModel)]="action['from'][1]">
              <option value="">Year</option>
              <option value="2025">2025</option>
              <option value="2026">2026</option>
              <option value="2027">2027</option>
              <option value="2028">2028</option>
              <option value="2029">2029</option>
              <option value="2030">2030</option>
              <option value="2031">2031</option>
              <option value="2032">2032</option>
              <option value="2033">2033</option>
              <option value="2034">2034</option>
              <option value="2035">2035</option>
            </select>
          </div>
        </div>
        <div class="to">
          <div>
            To:
          </div>
          <div>
            <select [disabled]="readOnly" [(ngModel)]="action['to'][0]">
              <option value="">Month</option>
              <option value="1">January</option>
              <option value="2">February</option>
              <option value="3">March</option>
              <option value="4">April</option>
              <option value="5">May</option>
              <option value="6">June</option>
              <option value="7">July</option>
              <option value="8">August</option>
              <option value="9">September</option>
              <option value="10">October</option>
              <option value="11">November</option>
              <option value="12">December</option>
            </select>
            <select [disabled]="readOnly" [(ngModel)]="action['to'][1]">
              <option value="">Year</option>
              <option value="2025">2025</option>
              <option value="2026">2026</option>
              <option value="2027">2027</option>
              <option value="2028">2028</option>
              <option value="2029">2029</option>
              <option value="2030">2030</option>
              <option value="2031">2031</option>
              <option value="2032">2032</option>
              <option value="2033">2033</option>
              <option value="2034">2034</option>
              <option value="2035">2035</option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <button *ngIf="!readOnly" class="btn btn-link" (click)="addActionPlan()"><i class="fa fa-plus" aria-hidden="true"></i> Add Action plan</button>

    <textarea [disabled]="readOnly" placeholder="Remarks and milestones." class="hero-textarea-adjust" [(ngModel)]="remarksAndMilestones"></textarea>

  </div>

</div>

<div class="relevance-actions">
  <button *ngIf="!readOnly" class="btn btn-hero btn-hero-primary" (click)="onSave()">Save</button>
</div>
